import { createContext } from 'react';

/**
 * The element at the end of the Title Search Rail where Review mode lists its
 * documents (through a portal), as the BA Rail lists its documents.
 *
 * `undefined` outside a Title Search Workspace (Review mode then lists the
 * documents beside the viewer). `null` inside one, until the Rail has mounted.
 */
export const RailSlotContext = createContext<HTMLElement | null | undefined>(undefined);
